import React from "react";

const SvgIcnQrcode = props => (
  <svg
    id="icn_qrcode_svg__\u30EC\u30A4\u30E4\u30FC_1"
    data-name="\u30EC\u30A4\u30E4\u30FC 1"
    width={24}
    height={24}
    {...props}
  >
    <defs>
      <style>
        {
          ".icn_qrcode_svg__cls-1{fill:#4a4b4c}.icn_qrcode_svg__cls-2{fill:#fff}"
        }
      </style>
    </defs>
    <path className="icn_qrcode_svg__cls-1" d="M3 3h18v18H3z" />
    <path
      className="icn_qrcode_svg__cls-2"
      d="M5 5h7v7H5zM12 12h7v7h-7zM15 5h4v4h-4zM5 15h4v4H5z"
    />
    <path className="icn_qrcode_svg__cls-1" d="M7 7h3v3H7zM14 14h3v3h-3z" />
  </svg>
);

export default SvgIcnQrcode;
